// extracted by mini-css-extract-plugin
export default {"container":"NotificationSettings_container__eDq1i"};